import ServicePage from "./ServiceTemplate";
export default function FasciaScraper() { return <ServicePage serviceId="fascia-scraper" />; }
